import { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tab as TabType } from "../types";

type Props = {
  tabs: TabType[];
  redirectToFirst?: boolean;
  onChange?: (index: number) => void;
};

interface UseTabs {
  value: number;
  onChange: (e: React.SyntheticEvent, index: number) => void;
}

export const useTabs = (props: Props): UseTabs => {
  const { tabs, redirectToFirst } = props;

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const pathIndex = useMemo((): number => {
    return tabs.findIndex((tab) => {
      if (tab.parentUrl) {
        return pathname.startsWith(tab.parentUrl);
      }
      return pathname.startsWith(tab.url.split("?")[0] || tab.url);
    });
  }, [pathname, tabs]);

  const initialValue = pathIndex !== -1 ? pathIndex : 0;

  useEffect(() => {
    if (pathIndex === -1 && tabs[0]?.url && redirectToFirst) {
      setValue(0);
      navigate(tabs[0].url, { replace: true });
    } else {
      setValue(pathIndex);
    }
  }, [pathIndex, tabs, navigate, redirectToFirst]);

  const [value, setValue] = useState<number>(initialValue);

  const onChange = (_e: React.SyntheticEvent, nextIndex: number) => {
    const nextTab = tabs[nextIndex];
    setValue(nextIndex);
    if (nextTab) {
      setTimeout(() => navigate(nextTab.url), 300);
    }
    props.onChange?.(nextIndex);
  };

  return {
    onChange,
    value,
  };
};
